import React from "react";
import LocalizationManagerWrapper from "../LocalizationManager";
const Skeleton = /* @__PURE__ */ React.createElement(React.Fragment, null);
const createLocalization = (id, resources, loadingElement = Skeleton) => {
  const Localization = ({ locale = "en-gb", children }) => /* @__PURE__ */ React.createElement(LocalizationManagerWrapper, {
    id,
    locale,
    resources,
    loadingElement
  }, children);
  Localization.displayName = `createLocalization(LocalizationManager)`;
  return Localization;
};
var createLocalization_default = createLocalization;
export {
  createLocalization_default as default
};
